// src/components/common/ThemeToggle.tsx
import { useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
    Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui";
import { useTheme } from '@/contexts/theme-context';

export default function ThemeToggle() {
    const { theme, setTheme } = useTheme();
    const { t } = useTranslation();

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'd') {
                e.preventDefault();
                setTheme(theme === "dark" ? "light" : "dark");
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [theme, setTheme]);

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="rounded-full"
                        onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                    >
                        <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" size={20} strokeWidth={1.5} />
                        <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" size={20} strokeWidth={1.5} />
                        <span className="sr-only">{t("header.toggleTheme")}</span>
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{t("header.toggleTheme", { theme: theme === "dark" ? "light" : "dark" })}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}